import React, { useState } from "react";
import GlobalStyles from "src/styles/global";
import ReloadComponent from "./components/ReloadComponent";

import {ReloadAnimationContext} from "./context";

const ReloadAnimationProvider: React.FC = ({children}) => {
	const [executeReload, setExecuteReload] = useState(false);
	const [executeHotReload, setExecuteHotReload] = useState(false);

	const reload = (ms?: number) => {
		setExecuteReload(true);
		window.setTimeout(() => {
			setExecuteReload(false);
		}, ms ?? 2600);
	};

	const hotReload = (ms?: number) => {
		setExecuteHotReload(true);
		window.setTimeout(() => {
			setExecuteHotReload(false);
		}, ms ?? 2600);
	};

	return (
		<ReloadAnimationContext.Provider value={{reload, hotReload}}>
			{executeHotReload && <ReloadComponent />}
			{executeReload ? <> <ReloadComponent /> <GlobalStyles /> </> : children}
		</ReloadAnimationContext.Provider>
	);
};

export default ReloadAnimationProvider;
